import React from "react";

const greetings = {
  en: {
    morning: "Good Morning",
    afternoon: "Good Afternoon",
    evening: "Good Evening",
    night: "Good Night",
  },
  hi: {
    morning: "शुभ प्रभात",
    afternoon: "शुभ अपराह्न",
    evening: "शुभ संध्या",
    night: "शुभ रात्रि",
  },
};

const getGreetingKey = () => {
  const hour = new Date().getHours();

  if (hour >= 5 && hour < 12) return "morning";
  if (hour >= 12 && hour < 17) return "afternoon";
  if (hour >= 17 && hour < 21) return "evening";
  return "night";
};

const GreetingMessage = ({
  name = "",
  language = "auto",
  className = "text-gray-800",
  style = {},
}) => {
  const greetingKey = getGreetingKey();

  // Detect browser language
  const userLang =
    language === "auto" ? (navigator.language || "en").slice(0, 2) : language;

  const lang = greetings[userLang] ? userLang : "en";

  const greeting = greetings[lang][greetingKey];

  return (
    <div className={className} style={style}>
      {greeting}
      {name && `, ${name}`}!
    </div>
  );
};

export default GreetingMessage;
